<template>
  <v-row
    align="center"
    justify="center"
    :style="backgroundStyle"
    class="header"
    no-gutters
  >
    <v-col cols="auto">
      <h1 class="text-h4 text-md-h1 text-no-wrap font-weight-medium shadow font">Yohann Hamonic</h1>
      <v-divider dark class="my-md-2"></v-divider>
      <h2 class="text-center text-h5 text-md-h2 font-weight-thin shadow font">Photographies</h2>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "parallaxHeader",
  data: () => ({
    model: 0,
    colors: ["primary", "secondary", "yellow darken-2", "red", "orange"],
  }),
  computed: {
    backgroundStyle() {
      return {
        background: "#1e1e1e",
        "background-size": "cover",
        "background-image": this.$store.state.background
          ? "url(" + this.$store.state.background + ")"
          : "none",
      };
    },
  },
};
</script>

<style scoped>
.header {
  height: 100vh;
}
.shadow {
  color: white;
  text-shadow: 1px 1px 2px black;
}
.text-h4.font,
.text-md-h1.font,
.text-h5.font,
.text-md-h2.font {
  font-family: "Dancing Script", cursive !important;
}
</style>